import { h } from '@atomify/jsx';
import { MapInfobox } from '@bpd-library/types';

import { ButtonA } from '../../atoms/button';
import { Image } from '../../atoms/image';

interface InfoboxInterface extends MapInfobox {
    onClose: () => void;
    openInTab?: boolean;
}

export const Infobox = ({
    title,
    image,
    tags,
    description,
    link,
    onClose,
    openInTab,
}: InfoboxInterface) => (
    <div class="c-infobox">
        <button class="infobox__close" onClick={onClose}>
            <bpd-svg name="icons-close" />
        </button>
        {image && title && (
            <div class="infobox__image-container">
                <Image
                    classes="infobox__image"
                    image={image}
                    alt={title}
                    preload={{
                        width: 325,
                        height: 117,
                    }}
                />
            </div>
        )}
        <div class="infobox__wrapper">
            {title && <h3 class="infobox__title">{title}</h3>}
            {tags && <span class="infobox__tags">{tags?.join(', ')}</span>}
            {description && <p class="infobox__description">{description}</p>}
            {link && (
                <ButtonA
                    target={openInTab ? '_blank' : '_self'}
                    url={link}
                    label="Bekijk het gebied"
                />
            )}
        </div>
    </div>
);
